import { BookingStepTopBar } from "../components/BookingStepTopBar"
import { PriceDetailsCard } from "../components/PriceDetailsCard"


export const Checkout = () => {

    return (
        <div className="w-full">
            <BookingStepTopBar />
            <div className="w-full bg-gray-100 min-h-screen pt-20 pb-4 px-10 flex justify-between">
                <div className="w-full flex flex-col items-center space-y-8 px-10">
                    <div className="w-full px-4 py-3 flex items-center gap-40 bg-white rounded-md">
                        <span className="text-sm font-semibold">Service Date: <span className="text-gray-500 font-medium">11/20/2025</span></span>
                        <span className="text-sm font-semibold">Name: <span className="text-gray-500 font-medium">John Doe</span></span>
                    </div>

                    <div className="w-full bg-white rounded-md p-3">
                        <div className="text-sm text-black font-semibold border-b py-2">
                            Select Payment Method
                        </div>

                        <div className="border rounded-md p-3 mt-2">
                            <div className="text-sm text-black font-semibold border-b flex items-center gap-2 py-2">
                                <input type="radio" id="credit_card" name="payment_method" value="Credit Card" /> <span>Credit Card</span>
                            </div>
                            <div className="w-full py-3 space-y-2">
                                <input type="text" className="w-full text-gray-500 bg-gray-100 p-2 rounded-md border" placeholder="Card Number" />
                                <input type="text" className="w-full text-gray-500 bg-gray-100 p-2 rounded-md border" placeholder="Name on Card" />
                                <div className="flex items-center gap-4">
                                    <input type="text" className="w-full text-gray-500 bg-gray-100 p-2 rounded-md border" placeholder="Expiration Date (MM/YY)" />
                                    <input type="text" className="w-full text-gray-500 bg-gray-100 p-2 rounded-md border" placeholder="CVV" />
                                </div>
                            </div>
                        </div>
                        <div className="border rounded-md p-3 mt-4">
                            <div className="text-sm text-black font-semibold flex items-center gap-2">
                                <input type="radio" id="paypal" name="payment_method" value="PayPal" /> <span>PayPal</span>
                            </div>
                        </div>
                    </div>
                </div>
                <PriceDetailsCard />
            </div>
        </div>
    )
}